<template>
  <hm-content title="">
    <div class="table-panel flex flex-start mb20">
      <div>
        优惠券筛选：
        <el-select
          size="small"
          v-model="searchCondition.couponType"
          class="mr10"
          clearable
          placeholder="请选择优惠券类别"
        >
          <el-option label="全部" value="3"></el-option>
          <el-option label="满减券" value="0"></el-option>
          <el-option label="折扣券" value="1"></el-option>
          <el-option label="运费券" value="2"></el-option>
        </el-select>
        <el-input
          v-if="searchCondition.couponType === '0'"
          clearable
          type="number"
          v-model.trim="searchCondition.minValue"
          placeholder="面值区间"
          size="small"
          class="ml10"
        ></el-input>
        <span v-if="searchCondition.couponType === '0'">--</span>
        <el-input
          v-if="searchCondition.couponType === '0'"
          clearable
          type="number"
          v-model.trim="searchCondition.maxValue"
          placeholder="面值区间"
          size="small"
          class="mr10"
        ></el-input>
        <el-input
          v-if="searchCondition.couponType === '1'"
          clearable
          type="number"
          v-model.trim="searchCondition.minValue"
          placeholder="折扣区间"
          size="small"
          class="ml10"
        ></el-input>
        <span v-if="searchCondition.couponType === '1'">--</span>
        <el-input
          v-if="searchCondition.couponType === '1'"
          clearable
          type="number"
          v-model.trim="searchCondition.maxValue"
          placeholder="折扣区间"
          size="small"
          class="mr10"
        ></el-input>
      </div>
    </div>
    <div class="table-panel flex flex-wrap mb20">
      <div class="flex item-center">
        统计时段：
      </div>
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        size="small"
        class="ml20"
        style="width:400px"
        clearable
      ></el-date-picker>
    </div>
    <div class="flex flex-between mb20">
      <el-button type="primary" size="small" @click="search"
        >生成报表</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="reportCouponList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponType"
          label="优惠券类别"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponName"
          label="优惠券名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="couponAccount"
          label="券面值"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.couponType === '满减券'"
                >¥{{ scope.row.couponAccount }}</span
              >
              <span v-if="scope.row.couponType === '折扣券'"
                >{{ scope.row.couponAccount }}折</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="minLevelAccount"
          label="使用门槛"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.minLevelAccount">
              <span>满{{ scope.row.minLevelAccount }}元可用</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useTimeInterval"
          label="使用时段"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relOrderNum"
          label="关联订单数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relOrderAccount"
          label="关联订单销售额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendNum"
          label="发放数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useNum"
          label="使用数"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="reportCouponList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        applyDate: [],
        minValue: "",
        maxValue: ""
      },
      currentPage: 1,
      pageSize: 10,
      isOutputing: false
    };
  },
  computed: mapGetters(["reportCouponList"]),
  watch: {},
  created() {},
  mounted() {
    this.getParamsCookie();
    // this.queryList();
  },
  methods: {
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.setParamsCookie();
      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      if(!searchCondition.startDate || !searchCondition.endDate){
        this.$message({
          message: "请选择统计时段!",
          type: "warning"
        });
        return;
      }
      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryReportCouponList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "couponListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "couponListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.startDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";

      Object.assign(params, searchCondition);

      return this.$store.dispatch("queryReportCouponList", params);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            res.result.records.forEach(v => {
              v.minLevelAccount = "满" + v.minLevelAccount + "元可用";
              if (v.couponType === "满减券") {
                v.couponAccount = "¥" + v.couponAccount;
              } else if (v.couponType === "折扣券") {
                v.couponAccount = v.couponAccount + "折";
              }
            });
            const list = res.result.records;
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            let title = "优惠券报表";

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
